var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "settings"
    }
  }, [_c('SubNavigation', {
    staticClass: "ma-4",
    attrs: {
      "items": _vm.navItemsWithPermission
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }